import { useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import { useParams } from 'react-router-dom'

import { FRONT_PAGE_OFFERS_TYPES } from 'constants/offerList'
import TextButton from 'LuxKit/Button/TextButton'
import useOfferList from 'hooks/Offers/useOfferList'
import GeoContext from 'contexts/geoContext'
import { take } from 'lib/array/arrayUtils'
import OfferListOfferTile from 'components/OfferList/OfferListTiles/OfferListOfferTile'

import ErrorBoundary from 'components/Common/ErrorBoundary/ErrorBoundary'

const Buttons = styled.div`
  margin-top: ${rem(40)};
  text-align: center;

  * + * {
    margin-inline-start: ${rem(20)};
  }
`

export function PaginatedOffersPage() {
  const intl = useIntl()
  const { currentRegionCode } = useContext(GeoContext)
  const { pageNum: pageNumParam } = useParams<'pageNum'>()

  const pageNum = useMemo(() => parseInt(pageNumParam ?? '1'), [pageNumParam])

  const filters = useMemo((): App.OfferListFilters => {
    return {
      offerTypes: FRONT_PAGE_OFFERS_TYPES(currentRegionCode),
    }
  }, [currentRegionCode])

  const offerList = useOfferList(filters)

  const endOfferIndex = pageNum * 12
  const hasMore = endOfferIndex < offerList.offerIds.length
  const offersToShow = take(offerList.offerIds, 12, (pageNum - 1) * 12)

  return <div>
    <ErrorBoundary fallback={null}>

    </ErrorBoundary>
    {offersToShow.map((id, index) => <OfferListOfferTile
      key={id}
      offerId={id}
      position={index}
      tileStyle="frontpage"
    />)}
    <Buttons>
      {pageNum > 1 &&
        <TextButton kind="primary" to={`/page/${pageNum - 1}`} rel="prev">
          {intl.formatMessage({
            id: 'ekMd6jnldB2JreYOPAxy',
            defaultMessage: 'Previous',
            description: 'Action button to navigate to the previous page of offers',
          })}
        </TextButton>}

      {hasMore &&
        <TextButton kind="primary" to={`/page/${pageNum + 1}`} rel="next">
          {intl.formatMessage({
            id: 'sJwUJ0s0-uFkjrQYSmdJ',
            defaultMessage: 'Next',
            description: 'Action button to navigate to the next page of offers',
          })}
        </TextButton>}
    </Buttons>
  </div>
}

export default PaginatedOffersPage
